<template>
  <div class="m-playtest">
    <template v-if="!loading">
      <div id="m-playtest__hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')" class="m-playtest__hero">
        <div class="m-playtest__hero--particles-container">
          <div v-for="p in particleCount" :key="p" class="m-playtest__hero--particles-container-particle-container">
            <div class="m-playtest__hero--particles-container-particle-container-particle"></div>
          </div>
        </div>
        <div
          id="m-playtest__hero--signup-btn"
          class="m-playtest__hero--signup-btn"
          @click="scrollToContent"
          @mousemove="(e) => moveHandCursor(e)"
          @mouseleave="resetHandCursor"
        >
          <div ref="handCursor" class="m-playtest__hero--signup-btn-mshand"></div>
        </div>
      </div>
      <div
        id="m-playtest__content"
        v-observe-visibility="observeVisibilitySettings(1, 'Content')"
        class="m-playtest__content"
      >
        <div class="m-playtest__content--title">Excited for Global MapleStory Classic World?</div>
        <div class="m-playtest__content--desc">
          Here's your chance to get an exclusive first look! Sign up now and complete a quick survey for a chance to be
          selected for an upcoming <br class="mobile" />in-person playtest.
        </div>
        <div class="m-playtest__content--desc">
          As a playtester, you'll get early access to <br class="mobile" />Global MapleStory Classic World in
          development, share your thoughts directly with the dev team, and help shape the future of the game! As a token
          of <br class="mobile" />our appreciation, participants are eligible to <br class="mobile" />receive gift cards
          and NX Cash.
        </div>
        <div class="m-playtest__content--desc">
          We're currently prioritizing participants located in Southern California who can travel to our Nexon America
          office in El Segundo, CA. <br />Don't miss this rare opportunity to be part of MapleStory history—sign up
          today!
        </div>
        <div class="m-playtest__content--checkbox">
          <!-- <input
            id="m-playtest__content--checkbox-input"
            v-model="agreeCheckbox"
            type="checkbox"
            class="m-playtest__content--checkbox-input"
          /> -->
          <label class="m-playtest__content--checkbox m-playtest__content--checkbox-label">
            Signup for the Global MapleStory Classic World playtest is closed! If you have signed up, you are on our
            list and you'll still have a chance of being selected for one of our playtests. If you haven't signed up,
            don't worry! There will be other opportunities - and more details on that later!
            <!-- <span
              >By checking this box, you agree to our
              <a :href="termsOfUseLink" target="_blank" class="m-playtest__content--checkbox-label-link"
                >Terms of Use</a
              >
              and acknowledge that you have read and understand our
              <a :href="privacyPolicyLink" target="_blank" class="m-playtest__content--checkbox-label-link"
                >Privacy Policy</a
              >.</span
            > -->
          </label>
        </div>
        <div
          id="m-playtest__content--signup-btn"
          class="m-playtest__content--signup-btn disabled"
          @click="signup"
        ></div>
        <div class="m-playtest__content--footer">
          <a :href="privacyPolicyLink" target="_blank">Privacy Policy</a>
          <a :href="termsOfUseLink" target="_blank">Terms of Use</a>
          <a :href="cookiePolicyLink" target="_blank">Cookie Policy</a>
        </div>
      </div>
    </template>

    <transition name="modal" appear @after-leave="afterModalClose">
      <aside
        v-if="showErrorModal || showAlreadySignedUpModal"
        ref="modal"
        class="m-playtest__modal"
        tabindex="-1"
        @keyup.esc="closeModal"
      >
        <dialog
          open
          class="m-playtest__modal__dialog"
          :class="{
            'm-playtest__modal__dialog--error': showErrorModal,
            'm-playtest__modal__dialog--already-signed-up': showAlreadySignedUpModal,
          }"
        >
          <div class="m-playtest__modal__dialog__close" @click.self="closeModal" />
          <div class="m-playtest__modal__dialog__body">
            <template v-if="showErrorModal">
              <div class="m-playtest__modal__dialog__body--title">Error</div>
              <div class="m-playtest__modal__dialog__body--desc">An error has occurred. Please try again later.</div>
            </template>
            <template v-if="showAlreadySignedUpModal">
              <div class="m-playtest__modal__dialog__body--title">Already Signed Up!</div>
              <div class="m-playtest__modal__dialog__body--desc">
                Thanks for signing up - we've received your information.
              </div>
              <div class="m-playtest__modal__dialog__body--desc">
                If you want to revisit your survey, please use this link:
                <a :href="surveyLink" target="_blank" class="m-playtest__modal__dialog__body--desc--link"
                  >Go to Survey</a
                >
              </div>
            </template>
            <div class="m-playtest__modal__dialog__body--btn" @click="closeModal">OK</div>
          </div>
        </dialog>
      </aside>
    </transition>
  </div>
</template>

<script>
  import '@/assets/scss/microsites/playtest/index.scss'
  import Cookie from '@/services/browser/Cookie'
  import Responsive from '@/services/browser/Responsive'
  import Util from '@/services/browser/Util'
  import axios from 'axios'
  import { gsap } from 'gsap'
  import { defineComponent } from 'vue'
  import { ObserveVisibility } from 'vue-observe-visibility'

  const _PLAYTEST_API_URL_ = '/api/maplestory/v1/events/100/user'
  const _PRIVACY_POLICY_LINK_ = 'https://www.nexon.com/main/legal/privacy'
  const _TERMS_OF_USE_LINK_ = 'https://www.nexon.com/main/legal/tou'
  const _COOKIE_POLICY_LINK_ = 'https://www.nexon.com/main/cookie-policy'
  const _SURVEY_MONKEY_LINK_ = 'https://www.surveymonkey.com/r/MGFRZ65?rsid='
  const _PARTICLE_COUNT_ = 100

  export default defineComponent({
    name: 'Microsite Playtest',
    directives: {
      'observe-visibility': ObserveVisibility,
    },
    components: {},
    // async beforeRouteEnter(to, _from, next) {
    //   const fromSignup = to?.query?.from_signup || false
    //   if (fromSignup) {
    //     try {
    //       const getResponse = await axios.get(_PLAYTEST_API_URL_)
    //       const getUuid = getResponse?.data?.uuid || ''
    //       if (getUuid) {
    //         next((vm) => vm.openAlreadySignedUpModal(getUuid))
    //       } else {
    //         const postResponse = await axios.post(_PLAYTEST_API_URL_, {})
    //         const postUuid = postResponse?.data?.uuid || ''
    //         if (postUuid) window.location.href = `${_SURVEY_MONKEY_LINK_}${postUuid}`
    //         next((vm) => (postUuid ? false : vm.openErrorModal()))
    //       }
    //     } catch (e) {
    //       next((vm) => vm.openErrorModal())
    //     }
    //   } else {
    //     next()
    //   }
    // },
    props: {},
    data() {
      return {
        loading: true,
        userData: null,
        privacyPolicyLink: _PRIVACY_POLICY_LINK_,
        termsOfUseLink: _TERMS_OF_USE_LINK_,
        cookiePolicyLink: _COOKIE_POLICY_LINK_,
        agreeCheckbox: false,
        originalHandCursorPosition: null,
        particleCount: _PARTICLE_COUNT_,
        showErrorModal: false,
        showAlreadySignedUpModal: false,
        surveyLink: '',
      }
    },
    unmounted() {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted() {
      Responsive.init({ debounce: 250 })
      setTimeout(() => {
        // wait for the responsive init
        this.loading = false

        window.dataLayer.push({
          pageType: 'Microsite',
          micrositeName: 'Playtest',
          micrositePhase: '1',
        })

        window.addEventListener('resize', this.handleResize)
      }, 210)
      Cookie.set('mapleplaytest', 'true')
    },
    methods: {
      playFree() {
        Util.playFree()
        this.clickTracking({
          interaction: 'button_click',
          sectionNumber: 0,
          sectionName: 'Header',
          sectionContent: 'Play Free CTA',
        })
      },
      observeVisibilitySettings(id, name, threshold = 0.3) {
        return {
          callback: (isVisible) => (isVisible ? this.viewTracking({ id, name }) : null),
          intersection: { threshold: threshold },
          throttle: 1000,
          once: true,
        }
      },
      clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
        window.dataLayer.push({
          event: 'standardMicrositeTrackingEvent',
          interaction: interaction,
          micrositeSectionNumber: sectionNumber,
          micrositeSectionName: sectionName,
          micrositeSectionContent: sectionContent,
          ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
        })
      },
      viewTracking({ id, name }) {
        window.dataLayer.push({
          event: 'standardMicrositeTrackingEvent',
          interaction: 'section_view',
          micrositeSectionNumber: id,
          micrositeSectionName: name,
        })
      },
      scrollToContent() {
        document.getElementById('m-playtest__content--signup-btn').scrollIntoView({ behavior: 'smooth' })
      },
      async signup() {
        if (!this.agreeCheckbox) return
        try {
          const getResponse = await axios.get(_PLAYTEST_API_URL_)
          const getUuid = getResponse?.data?.uuid || ''
          if (getUuid) {
            this.openAlreadySignedUpModal(getUuid)
          } else {
            const postResponse = await axios.post(_PLAYTEST_API_URL_, {})
            const postUuid = postResponse?.data?.uuid || ''
            if (postUuid) window.location.href = `${_SURVEY_MONKEY_LINK_}${postUuid}`
            else this.openErrorModal()
          }
        } catch (e) {
          if (e?.response?.status === 401) {
            this.redirectToLogin()
          } else {
            this.openErrorModal()
          }
        }
      },
      redirectToLogin() {
        location.href = `https://${import.meta.env.VITE_ENV_PREFIX}www.nexon.com/account/login?return_url=${
          window.location.href
        }?from_signup=true`
      },
      handleResize() {
        setTimeout(() => {
          this.setOriginalHandCursorPosition()
        }, 500)
      },
      setOriginalHandCursorPosition() {
        if (!this.$refs.handCursor) return
        const handCursor = this.$refs.handCursor
        this.originalHandCursorPosition = { offsetLeft: handCursor.offsetLeft, offsetTop: handCursor.offsetTop }
      },
      moveHandCursor(e) {
        if (!this.$refs.handCursor) return
        const handCursor = this.$refs.handCursor
        if (!this.originalHandCursorPosition) this.setOriginalHandCursorPosition()
        gsap.to(handCursor, {
          x: e.offsetX - this.originalHandCursorPosition.offsetLeft,
          y: e.offsetY - this.originalHandCursorPosition.offsetTop,
          duration: 0.25,
          ease: 'power3',
        })
      },
      resetHandCursor() {
        if (!this.$refs.handCursor) return
        const handCursor = this.$refs.handCursor
        gsap.to(handCursor, {
          x: 0,
          y: 0,
          duration: 0.25,
          ease: 'back.out',
        })
      },
      openErrorModal() {
        this.showErrorModal = true
        this.showAlreadySignedUpModal = false
        this.openModal()
      },
      openAlreadySignedUpModal(uuid) {
        this.surveyLink = `${_SURVEY_MONKEY_LINK_}${uuid}`
        this.showAlreadySignedUpModal = !!uuid
        this.showErrorModal = !uuid
        this.openModal()
      },
      openModal() {
        document.body.classList.add('modal-active')
        this.$nextTick(() => {
          this.$refs.modal.focus()
        })
      },
      closeModal() {
        this.showErrorModal = false
        this.showAlreadySignedUpModal = false
        this.surveyLink = ''
      },
      afterModalClose() {
        document.body.style.paddingRight = ''
        document.body.classList.remove('modal-active')
      },
    },
  })
</script>
